/*
 * WaWiGruppenApp.tsx - Warenwirtschaftliche Gruppendaten.
 *
 * Siehe auch StammGruppenApp.
 *
 * Created by Dr. Maximillian Dornseif 2021-11-01 in huWaWi3 23.2.2
 * Copyright (c) 2021, 2023 HUDORA GmbH
 */

import React from 'react'
import { navigate } from 'wouter/use-location'

import { IEntitySubPage3 } from '../lib/components/ke/EntityPage3'
import { KindListe3 } from '../lib/components/ke/KindListe3'
import { KindPage3 } from '../lib/components/ke/KindPage3'
import { GRUPPE_ENTITY_QUERY, GRUPPE_SUGGESTIONS_QUERY } from '../Stammdaten/StammGruppenAppQueries'
import {
  GRUPPEAKTIV_LIST_QUERY,
  GRUPPEN_MITGLIEDER_RESERVIERUNGSPOS_QUERY,
  RESERVIERUNGSPOS_LIST_QUERY,
  RESERVIERUNG_LIST_QUERY,
} from './WaWiGruppenAppQueries'

/** Rendert entweder die Startseite (Suche) oder eine Gruppenseite
 * */
export const WaWiGruppenApp = (props) => {
  const subPages: IEntitySubPage3[] = [
    {
      title: 'Blockaufträge',
      path: 'r',
      render: (entity) => (
        <KindListe3
          title={'Offene Gruppen-Blockaufträge'}
          schemaName={'HwReservierung'}
          listQuery={RESERVIERUNG_LIST_QUERY}
          listQueryVars={{ nr: entity.designator }}
        />
      ),
    },
    {
      title: 'Blockauftragsspositionen',
      path: 'p',
      render: (entity) => (
        <KindListe3
          title={'Offene Gruppen-Resevierungspositionen'}
          schemaName={'HwReservierungsPosition'}
          hideExcept={[
            'reservierungsnr',
            'item.produkt.kategorie',
            'bartnr',
            'item.name',
            'name',
            'anlieferdatum_von',
            'anlieferdatum_bis',
            'menge_bestellt',
            'menge_geliefert',
            'menge_offen',
            'item.zukunft.freie_menge',
            'item.zukunft.frei_ab',
            'item.zukunft.buchbestand',
            'item.zukunft.zukuenftiger_zulauf',
            'item.zukunft.naechster_zulauf',
            'item.zukunft.zukuenftiger_ablauf',
            'item.zukunft.naechster_ablauf',
            'item.preisResolved.uvp',
            'item.produkt.designator',
          ]}
          listQuery={RESERVIERUNGSPOS_LIST_QUERY}
          listQueryVars={{ nr: entity.designator }}
        />
      ),
    },
    {
      title: 'Mitglieder Blockauftragspositionen',
      path: 'm',
      render: (entity) => (
        <KindListe3
          schemaName={'HwReservierungsPosition'}
          listQuery={GRUPPEN_MITGLIEDER_RESERVIERUNGSPOS_QUERY}
          listQueryVars={{ nr: entity.designator }}
          title={'Offene Mitglieder-Resevierungspositionen'}
        />
      ),
    },
  ]

  return (
    <KindPage3
      suggestionQuery={GRUPPE_SUGGESTIONS_QUERY}
      basePath={'/wawi'}
      componentPath={'g'}
      initialLimit={250}
      schemaName={'HwKundenGruppe'}
      title={'Gruppen'}
      subPages={subPages}
      listQuery={GRUPPEAKTIV_LIST_QUERY}
      entityQuery={GRUPPE_ENTITY_QUERY}
      hideExcept={['designator', 'name', 'ist_aktiv', 'updated_at', 'created_at']}
      entityCommandBarItems={[
        {
          key: 'stamm',
          text: 'in den Stammdaten',
          ariaLabel: 'Kunden-Stamm',
          iconProps: {
            iconName: 'MasterDatabase',
          },
          iconOnly: false,
          onClick: (e) => {
            navigate(window.location.pathname.replace('/wawi/g/', '/stamm/g/'))
          },
        },
      ]}
    />
  )
}
